import UserResults from "../users/UserResults";
import UserSearch from "../users/UserSearch";

const Home = () => {
  return (
    <>
      <UserSearch />
      <UserResults />
    </>
  );
};

export default Home;
